export const replaceAnchors = (htmlString: string) => {
  return htmlString.replace(/<a.*?>(.*)?<\/a>/g, '<span>$1</span>');
};
